import React, { memo, useEffect } from "react";
import Input from "./Input";
import { useDispatch } from "react-redux";
import { addModal } from "../../../libraries/state_reducers/widget/ModalsReducer";
import ModalKeys from "../../../const/ModalKeys";
import { useSelector } from "react-redux";
import { RootState } from "../../../libraries/state_reducers/store";
import { CountryCodeList } from "../../../model/country_code/CountryCodeModel";

type Props = {
  name: string;
  value?: string;
  code?: string;
  label?: string;
  validate?: boolean | false;
  handleOnChange?: (
    fieldName: string,
    fieldValue: string,
    isValid?: boolean | true
  ) => void;
  handleChangePrefix?: () => void;
  error?: boolean;

  handleEnter?: () => void;

  prefixType?: string | "text" | "icon"; // text, icon
  prefixText?: string;
  prefixIcon?: string;
  prefixIconFill?: boolean;
  prefixHandleClick?: () => void;

  suffixType?: string | "text" | "icon"; // text, icon
  suffixText?: string;
  suffixIcon?: string;
  suffixIconFill?: boolean;
  suffixHandleClick?: () => void;

  disabled?: boolean;
  callback: (detail: CountryCodeList) => void;
};

const PhoneNumber: React.FC<Props> = ({
  name = "",
  value = "",
  label = "",
  code = "",
  validate = false,
  handleOnChange,
  handleChangePrefix,
  error = false,
  handleEnter = undefined,

  prefixType,
  prefixText,
  prefixIcon,
  prefixIconFill = false,
  prefixHandleClick = undefined,
  suffixType,
  suffixText,
  suffixIcon,
  suffixIconFill = false,
  suffixHandleClick = undefined,

  disabled = false,
  callback,
}) => {
  const dispatch = useDispatch();

  const countryCodeDetail = useSelector(
    (state: RootState) => state.countryCode.countryCodeDetail
  );

  const handleChangePrefixFunc = () => {
    dispatch(
      addModal({
        id: ModalKeys.country_code_selection,
        title: "country_code",
        allowBottomSheet: true,
      })
    );
    if (handleChangePrefix !== undefined) {
      handleChangePrefix();
    }
  };

  const applyCountryCode = () => {
    if (countryCodeDetail != null && typeof callback === "function") {
      callback(countryCodeDetail);
    }
  };

  useEffect(() => {
    applyCountryCode();
    // eslint-disable-next-line
  }, [countryCodeDetail]);

  return (
    <Input
      type={`phone`}
      name={name}
      handleOnChange={handleOnChange}
      prefixHandleClick={handleChangePrefixFunc}
      value={value}
      validate={validate}
      label={label}
      error={error}
      handleEnter={handleEnter}
      prefixType={prefixType}
      prefixText={prefixText ?? code}
      prefixIcon={prefixIcon}
      prefixIconFill={prefixIconFill}
      suffixType={suffixType}
      suffixText={suffixText}
      suffixIcon={prefixType}
      suffixIconFill={suffixIconFill}
      suffixHandleClick={suffixHandleClick}
      disabled={disabled}
    />
  );
};

export default memo(PhoneNumber);
